import styled from 'styled-components';
import { ButtonGroupProps } from './ButtonGroup';
import { DropdownWrapper } from '../Dropdown/Dropdown';
import { buttonGroupTokens } from '../../tokens/components/ButtonGroup/tokens';
import { StyledButton } from '../Button/Button';

export const ButtonGroupWrapper = styled.nav<ButtonGroupProps>`
  border-radius: ${buttonGroupTokens.CoreBorderRadiusDefault};
  display: flex;
  flex-direction: ${({ theme }) =>
    theme.vertical ? 'column' : 'row'}; // when button group needs to be vertically oriented
  flex-wrap: nowrap;
  height: auto;
  white-space: nowrap;

  // Styles for Buttons inside Button Group but nested on different parents like dropdowns or Toggle Options
  ${DropdownWrapper} {
    z-index: 1;
    margin-right: -1px; // Add a negative margin to merge dropdown's borders on responsive view

    &:hover,
    &:focus-within {
      z-index: 2;
    }

    ${StyledButton} {
      border-radius: ${buttonGroupTokens.CoreBorderRadiusHorizontalLast};
    }

    // Reset Border Radius when dropdown is the only element inside ButtonGroup
    &:only-child {
      ${StyledButton} {
        border-radius: ${buttonGroupTokens.CoreBorderRadiusDefault};
      }
    }
  }
`;
